export const DEFAULT_MASTER_CONFIG = {
  target: 'master',
  hardware: {
    debug: true,
    buzzer_master_enabled: true,
    buzzer_alarm_enabled: true,
    buzzer_warning_enabled: true,
    buzzer_ui_enabled: true,
    speaker_enabled: true,
    rgb_enabled: true,
    relay_enabled: true,
    relay_inverted: false,
    button_emergency_enabled: true,
    allow_remote_emergency: false,
    endstop_enabled: true,
    door_sensor_enabled: true,
    door_sensor_inverted: false,
    intercom_enabled: false,
    buzzer_alarm_volume: 60,
    buzzer_warning_volume: 60,
    buzzer_ui_volume: 60,
    speaker_volume: 60,
    led_brightness: 150,
  },
  logic: {
    default_auth_door_open_sec: 5,
    door_held_event_interval_sec: 5,
    door_open_grace_period_sec: 60,
    alert_auto_silence_timeout_min: 5,
  },
};

export const DEFAULT_SLAVE_CONFIG = {
  target: 'slave',
  hardware: {
    debug: true,
    buzzer_master_enabled: true,
    buzzer_alarm_enabled: true,
    buzzer_warning_enabled: true,
    buzzer_ui_enabled: true,
    speaker_enabled: true,
    rgb_enabled: true,
    relay_enabled: false,
    relay_inverted: false,
    button_emergency_enabled: false,
    allow_remote_emergency: false,
    endstop_enabled: false,
    door_sensor_enabled: false,
    door_sensor_inverted: false,
    intercom_enabled: false,
    buzzer_alarm_volume: 60,
    buzzer_warning_volume: 60,
    buzzer_ui_volume: 60,
    speaker_volume: 60,
    led_brightness: 150,
  },
};

export const DEFAULT_WIFI_CONFIG = {
  ssid: 'BlueBuilding',
};
